import { makeStyles, mergeClasses } from '@griffel/react';
import type { GriffelClassNames } from '@ms/yammer-web-core-ui/dist/util/classNames';
import { getGutterValue } from '@ms/yammer-web-core-ui/dist/util/styles/gutters';
import { px } from '@ms/yammer-web-core-ui/dist/util/styling';
import { tokens } from '@ms/yammer-web-core-ui/dist/util/theme/fluent9';

export type CollapseIconButtonAppearance = 'subtle' | 'transparent';

const expandedHeight = 32;
const collapsedHeight = 36;

const useClasses = makeStyles({
  base: {
    minWidth: 'unset',
    paddingLeft: getGutterValue(1.5),
    paddingRight: getGutterValue(1.5),
  },
  subtle: {
    height: px(expandedHeight),
  },
  transparent: {
    height: px(collapsedHeight),
    ':hover': {
      color: tokens.colorNeutralForeground2,
    },
    ':hover:active': {
      color: tokens.colorNeutralForeground2,
    },
  },
});

export const useClassNames = (appearance: CollapseIconButtonAppearance): GriffelClassNames<'button'> => {
  const classes = useClasses();

  return {
    button: mergeClasses(classes.base, classes[appearance]),
  };
};
